import React, { Component } from 'react';
// import { LinkContainer } from 'react-router-bootstrap';
// import { Link } from 'react-router-dom'
import moment from 'moment';
// import Icons from '../../Components/Icons/Icons';
import {dismissActivityReminderDetails,getActivityReminderDetails,getUserTimeZone } from '../../Utils/UserFunctions';
import { parameterizedURLAccessToken } from '../../Utils/CommonFunctions';
// import { FaCarCrash } from 'react-icons/fa';
let reloadInterval = null;

class ReminderList extends Component {
	constructor(props) {
		super(props);
		this.state = {
            deletingId:null,
			ACTIVITY_REMINDER:this.props.ACTIVITY_REMINDER,
            // reminderMessage: null
		}
        this.eventSource = null;
    }
    componentDidUpdate = (prevProps) =>{
        if(prevProps.ACTIVITY_REMINDER!==this.props.ACTIVITY_REMINDER){
          this.setState({ACTIVITY_REMINDER:this.props.ACTIVITY_REMINDER});
        }
    }
    componentDidMount() {
        // const api =encodeURIComponent(parameterizedURLAccessToken('reminders/list'));
        // const timezone = encodeURIComponent(getUserTimeZone());
        // // const encodedUrl = encodeURIComponent(parameterizedURLAccessToken(API_Url));
        // const SSE_URL = `https://dev.shipcrm.org/reminder-events?api=${api}&timezone=${timezone}`;
        // //http://localhost:4000 https://dev.shipcrm.org
        // this.eventSource = new EventSource(SSE_URL);

        // this.eventSource.onmessage = (event) => {
        // const resData = JSON.parse(event.data);
        // if (resData.isExist === 200) {
        //     localStorage.setItem('ACTIVITY_REMINDER', JSON.stringify(resData.message));
        //     this.props.setReminderMessage(resData.message);
        // }
        // };

        // this.eventSource.onerror = (error) => {
        // console.error('SSE error:', error);
        // this.eventSource.close();
        // };
    }

    componentWillUnmount() {
        // console.log('unmount..');
        // if (this.eventSource) {
        // this.eventSource.close();
        // }
    }

	render() {
        const {reminderListPopupToogle} = this.props;
        const {ACTIVITY_REMINDER,deletingId} =  this.state;
      
        try{ 
            return (	
                <div className="row notifyBox animated fadeInUp reminderNotifyBox"  style={{display:'none'}}>
                   
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <h6 className="mb-0 last_light_color">{`Reminders`}</h6>
                                <a href="#" className="icon-right cursor-pointer" id="">
                                    <span className="badge badge-warning" onClick={e=>reminderListPopupToogle(false)}><i className="fas fa-times fa-lg"></i></span>
                                </a>
                            </div>
                            
                            <div className="list-group list-group-file-item list-group-reflow list-group-flush list-group-divider">
                            {(Object.keys(ACTIVITY_REMINDER).length>0)?
                                <ol className="activity-feed">
                                    {Object.entries(ACTIVITY_REMINDER).map(([key, remind]) => {
                                        //  const currentTime = moment().tz(getUserTimeZone()).format('YYYY-MM-DDTHH:mm');
                                            let isDisplayed = 0;
                                            let displayDateTime = (remind.NextFireTime!=='' && remind.NextFireTime!==undefined && remind.NextFireTime!==null)?moment(remind.NextFireTime, 'YYYY-MM-DDTHH:mm', true).format('YYYY-MM-DD hh:mm A'):'YYYY-MM-DD hh:mm';
                                            let displayDate = (remind.NextFireTime!=='' && remind.NextFireTime!==undefined && remind.NextFireTime!==null)?moment(remind.NextFireTime, 'YYYY-MM-DDTHH:mm', true).format("MMM Do YYYY"):'MMM YYYY';
                                            // console.log('remind.DisplayText',remind.DisplayText);
                                            // let displayCount = 0;
                                            return(
                                                <>
                                                <li className="feed-item feed-item-warning" key={`item-${key}`}>
                                                    {(deletingId===key)&& 
                                                        <div id="loaderBG" style={{position:'absolute',backgroundColor:'#fff'}}>
                                                            <div className="loader11" style={{position:'relative',left:'40%',top:'50%'}}></div>
                                                        </div> 
                                                    } 
                                                    
                                                    <time className="date text-info"> <span className="badge-info badge"> {displayDate} </span> </time>
                                                        <div className="d-flex align-items-center justify-content-between">
                                                        {(remind.OnlyDisplayText===false)?
                                                            <span className="text secondary_color">{displayDateTime}  <span className="primary_color cursor-pointer" onClick={(e=>this.dismissHandler(key))}>"Dismiss"</span> 
                                                            </span>
                                                        :''}
                                                        <ul>
                                                        {Object.entries(remind.DisplayText).map(([key, text]) => {
                                                            if(isDisplayed > 2) return null;

                                                            if(remind.DisplayText.hasOwnProperty('subject')) {
                                                                isDisplayed++;
                                                                return (
                                                                    <li key={key} title={remind.DisplayText.subject} className='text-right1 text-truncate1'>
                                                                        {remind.DisplayText.subject}
                                                                    </li>
                                                                );
                                                            } else if(key !== 'record_id') {
                                                                isDisplayed++;
                                                                return (
                                                                    <li key={key} title={text} className='text-right1 text-truncate1'>
                                                                        {text}
                                                                    </li>
                                                                );
                                                            }

                                                            return null; // Fallback in case no conditions match
                                                        })}
                                                        </ul>
                                                        </div>
                                                        
                                                            
                                                        
                                                        {/* <div className="d-flex align-items-center justify-content-between">
                                                                    <h6> Task Name </h6>
                                                                    <span className="text secondary_color">Date : Jan 15, 2021  <span className="primary_color cursor-pointer">"Dismiss"</span> </span>
                                                        </div> */}
                                                </li>
                                                </>
                                            )
                                    })}
                                    
                                </ol>
                            :<h6 className="p-3">{`No reminder exists`}</h6>}
                            </div> 
                        </div>
                    </div>
                </div> 
            );
        }catch(e){
            return('')
        }
	}

	dismissHandler = (remidId)=>{
    //    let ACTIVITY_REMINDER = {};
    //    let activityReminder  = localStorage.getItem('ACTIVITY_REMINDER');        try{
    //         if(activityReminder!==null && activityReminder!==undefined){
    //             ACTIVITY_REMINDER = JSON.parse(activityReminder);
    //             delete ACTIVITY_REMINDER[remidId];
    //             this.setState({ACTIVITY_REMINDER:ACTIVITY_REMINDER});
    //         }
    //     }catch(e){
   
    //     }
        this.setState({deletingId:remidId},()=>{
            dismissActivityReminderDetails(remidId,this.reloadActivityReminderList);
        })
    }
    reloadActivityReminderList = ()=>{
       let ACTIVITY_REMINDER = {};
       let activityReminder  = localStorage.getItem('ACTIVITY_REMINDER');
       console.log('activityReminder',activityReminder)
        try{
            if(activityReminder!==null && activityReminder!==undefined){
                ACTIVITY_REMINDER = JSON.parse(activityReminder);
                if(this.state.ACTIVITY_REMINDER!==ACTIVITY_REMINDER){
                    // clearInterval(reloadInterval);
                    this.setState({ACTIVITY_REMINDER:ACTIVITY_REMINDER});
                }
                
            }
        }catch(e){
   
        }
    }
	//REMINDER BLOCK END
} 

export default (ReminderList);

